module.exports = __webpack_public_path__ + "img/470.b720694d.png";